import i18next from "i18next";
import {
  checkAndAddPublishingCampaign,
  checkAndSaveUserOnboardingChecklist,
  checkAndShowNpsForm,
  startGetRecommendedSettingsPlatform,
} from "../../../actions/adsCampaigns";
import {
  removeNotification,
  updateNotification,
} from "../../../actions/alerts";
import { getPathDatabaseByRole } from "../../../actions/auth";
import { dismissCreativeJob } from "../../../actions/creativeJobs";
import { getCampaignOnboardingResumeFromAlert } from "./createAdsCampaignWizardUtils";
import {
  CAMPAIGN_GENERATED_ERROR,
  GENERATING_CAMPAIGN,
} from "../../../i18n/keysTranslations";
import {
  ALERTS_ASYNC_STATUS,
  CHECKLIST_CREATE_CAMPAIGN,
  NPS_RATING_ACTION_CREATE,
} from "../../../utils/constants";
import { CREATIVE_JOB_TYPES } from "../../../utils/errors";

const EMPTY_LOCATIONS = { contexts: [], locations: [] };

export const startGenerateInitialCampaign =
  ({ campaignID, setupFields = {}, platformData }) =>
  async (dispatch) => {
    if (!campaignID || !platformData?.platform) {
      return { ok: false };
    }

    const buttonAction = "generateInitial";
    const newPlatforms = [platformData.platform];
    const resolvedSetup = {
      context: setupFields.context || "",
      language: setupFields.language || "",
      locations: setupFields.locations || EMPTY_LOCATIONS,
      attachmentsFiles: setupFields.attachmentsFiles || [],
      fileNamesMapping: setupFields.fileNamesMapping || {},
    };
    const campaignValues = {
      ...resolvedSetup,
      platforms: newPlatforms,
    };
    const platformGeneratingData = {
      ...platformData,
      ...resolvedSetup,
    };

    dispatch(
      checkAndAddPublishingCampaign({
        campaignID,
        isCreating: false,
        isGenerating: true,
        status: ALERTS_ASYNC_STATUS.GENERATING,
        message: i18next.t(GENERATING_CAMPAIGN),
        progress: 0,
        platformGeneratingData,
        currentCampaign: campaignValues,
        newPlatforms,
        buttonAction,
        platform: platformData.platform,
      })
    );

    const response = await dispatch(
      startGetRecommendedSettingsPlatform({
        ...platformData,
        ...campaignValues,
        platforms: newPlatforms,
        campaignID,
        platformGeneratingData,
        currentCampaign: campaignValues,
        buttonAction,
      })
    );

    if (response?.ok) {
      dispatch(checkAndShowNpsForm(NPS_RATING_ACTION_CREATE));
      dispatch(checkAndSaveUserOnboardingChecklist(CHECKLIST_CREATE_CAMPAIGN));
      return response;
    }

    dispatch(
      updateNotification(response?.jobID || campaignID, {
        status: ALERTS_ASYNC_STATUS.ERROR,
        message: i18next.t(CAMPAIGN_GENERATED_ERROR),
        isCreating: false,
        isGenerating: false,
        jobType: CREATIVE_JOB_TYPES.generateRecommendedSettingsPlatform,
        buttonAction,
        platformGeneratingData,
        currentCampaign: campaignValues,
        platform: platformData.platform,
      })
    );

    return response;
  };

export const retryGenerateInitialCampaignFromAlert =
  (alert) => async (dispatch) => {
    const resume = getCampaignOnboardingResumeFromAlert(alert);
    if (!resume) {
      return { ok: false };
    }

    const notificationID = alert?.id || alert?.jobID || resume.campaignID;
    if (alert?.jobID) {
      const { userID: advertiserID } = dispatch(getPathDatabaseByRole());
      await dispatch(
        dismissCreativeJob({
          advertiserID,
          jobID: alert.jobID,
        })
      );
    }
    if (notificationID) {
      dispatch(removeNotification(notificationID));
    }

    return dispatch(
      startGenerateInitialCampaign({
        campaignID: resume.campaignID,
        setupFields: resume.setupFields,
        platformData: resume.platformData,
      })
    );
  };
